import vs from './project2.vertex.glsl';

export default {
  name: 'project2',
  vs,
  fs: vs
};
